import { nationality } from '@/api/common/master-lists'

export default {
  namespaced: true,
  state () {
    return {
      loading: false,
      items: sessionStorage.getItem('nationalities')
        ? JSON.parse(sessionStorage.getItem('nationalities'))
        : []
    }
  },
  getters: {
    hasItems: state => {
      return state.items.length > 0
    },
    japaneseNationalityID: state => {
      return state.items.length > 0 ? state.items.find(item => {
        return item.name.toLowerCase() === 'japan' || item.name === '日本'
      }).id : 0
    }
  },
  mutations: {
    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} items
     */
    setItems (state, items) {
      state.items = items
    },
    /**
     * Set the status.
     *
     * @param {*} state
     * @param {*} items
     */
    setLoading (state, loading) {
      state.loading = loading
    }
  },
  actions: {
    /**
     * Fetch items
     * If items is already populated skip the process
     *
     * @param { getters, dispatch}
     */
    softFetch ({ getters, dispatch }) {
      if (getters.hasItems) return
      dispatch('fetch')
    },

    /**
     * Fetch Items
     *
     * @param {commit, dispatch} object
     */
    fetch ({ commit, dispatch }) {
      commit('setLoading', true)

      nationality.index()
        .then(({ data }) => {
          commit('setItems', data)

          sessionStorage.setItem('nationalities', JSON.stringify(data))
        })
        .catch(({ response }) => {
          dispatch('httpException/handle', response, { root: true })
        })
        .finally(() => {
          commit('setLoading', false)
        })
    }
  }
}
